module.exports = __webpack_public_path__ + "img/home-choose.149dafb6.jpg";